import plural from 'helpers/plural'

angular
  .module 'filters'
  .filter 'pluralize', ->
    (word, number, includeCount) ->
      return if !word || (!number && number isnt 0)

      plural(word, number, includeCount)
